import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LaguageService } from './laguage.service';
import { ConfirmLogotComponent } from './shared-component/components/logout/confirm-logot/confirm-logot.component';
import { LoginService } from './authuntication/auth-service/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'admin';
  arabic: boolean = false;
  english: boolean = true;
  isLogin: boolean = false;
  isOpen: boolean = false;
  spinner: boolean = true;
  timer: any;
  language: any;
  body: any;

  constructor(private _AuthService: LoginService, public translate: TranslateService,
    private dialogRef: MatDialog, private _lang: LaguageService,
    private router: Router, public _title: Title) {
    this.language = this._lang.getValue();
    this.currentUserLogin();
  }

  ngOnInit(): void {
    this.startTimer();
    this.getLanguage();
    this.getTiltleOfRouter();
  }

  isArabic() {
    if (this.language.source._value === 'ar') {
      this.english = false;
      this.arabic = true;
    }
    else {
      this.arabic = false;
      this.english = true;
    }
  }

  isEnglish() {
    if (this.language.source._value === 'en') {
      this.arabic = false;
      this.english = true;
    } else {
      this.english = false;
      this.arabic = true;
    }
  }

  currentUserLogin() {
    this._AuthService.currentUser.subscribe(() => {
      if (this._AuthService.currentUser.getValue() != null) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    })
  }

  startTimer() {
    this.timer = setTimeout(() => {
      this.spinner = false;
    }, 300);
  }

  open(event: any) {
    this.isOpen = !this.isOpen
  }

  openDialog() {
    this.dialogRef.open(ConfirmLogotComponent)
  }

  useLanguage(language: string): void {
    this.translate.use(language);
  }

  changeCurrentLang(lang: string) {
    const body = document.getElementsByTagName('body');
    if (lang == "ar") {
      body[0].setAttribute('dir', 'rtl')
      this.translate.use(lang)
      localStorage.setItem('currentLang', 'ar')
      this._lang.setValue('ar')
    } else {
      this.translate.use(lang)
      body[0].setAttribute('dir', 'ltr')
      localStorage.setItem('currentLang', 'en')
      this._lang.setValue('en')
    }
  }

  getLanguage() {
    let lang = localStorage.getItem('currentLang');
    const body = document.getElementsByTagName('body');
    if (lang == "ar") {
      body[0].setAttribute('dir', 'rtl');
      this.translate.use(lang);
      localStorage.setItem('currentLang', 'ar');
    } else {
      body[0].setAttribute('dir', 'ltr')
      localStorage.setItem('currentLang', 'en')
    }
  }

  getTiltleOfRouter() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        let string = e.url,
          result = string.replace(/[/]/gi, "| ");
        this._title.setTitle(`alfa care ألفاكير ${result}`)
      }
    });
  }
}